package org.example.project.enginevertrieb

import org.example.project.utils.All
import org.w3c.dom.url.URL

/** Guard the read-only views against repeated records, including older API responses. */
internal fun distinctLinkedInContacts(contacts: List<All>): List<All> = contacts.distinctBy { contact ->
    runCatching {
        val url = URL(contact.linkedin)
        if (url.hostname.lowercase().removePrefix("www.") == "linkedin.com" && url.pathname.isNotBlank())
            url.pathname.trimEnd('/').lowercase() else ""
    }.getOrDefault("").ifBlank {
        listOf(contact.id, contact.vorname, contact.nachname, contact.firma, contact.email, contact.ansprechpartnerPosition)
            .joinToString("") { "${it.length}:$it" }
    }
}
